import { render, staticRenderFns } from "./DialogAddTopic.vue?vue&type=template&id=dedff42c"
import script from "./DialogAddTopic.vue?vue&type=script&lang=js"
export * from "./DialogAddTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports